export interface ApiResponseInvoiceIssuanceDetails {
  quintoAndarCnpj: string;
  errorMessage: string | null; 
}

export interface InvoiceIssuanceDetails {
  quintoAndarCnpj: string;
  errorMessage: string | null;
}

export const mapApiToInvoiceIssuanceDetails = (
  apiData: ApiResponseInvoiceIssuanceDetails
): InvoiceIssuanceDetails => {
  return {
    quintoAndarCnpj: apiData.quintoAndarCnpj,
    errorMessage: apiData.errorMessage,
  };
};